<template>
  <div>
    <!-- create dialog -->
    <dialogTemplate
      :openDialog="isOpen"
      :widthDialog="'450px'"
      :classDialog="'createDialog'"
      :offsetTop="''"
      @closeDialog="$emit('closeDialog')"
      @closed="$emit('closed')"
    >
      <template #body>
        <div>
          <h3 class="dialogTitle">Soạn thảo văn bản</h3>
          <el-form :model="form" :rules="rules" ref="form" label-position="left">
            <el-form-item label="Tên file văn bản" prop="name">
              <el-input
                type="textarea"
                :rows="2"
                resize="none"
                placeholder="nhập tên file"
                v-model="form.name"
                maxlength="100"
              >
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template #footer>
        <div class="flex-row flex__right form-button__action">
          <el-button
            type="success"
            size="mini"
            class="addDocs color__white bg__blue btn-none__border"
            @click="create"
          >
            <i class="far fa-check-circle font-size__small"></i>
            &nbsp;Soạn thảo
          </el-button>
          <el-button
            type="info"
            size="mini"
            class="btn__cancel btn-none__border"
            @click="cancel"
          >
            <i class="fas fa-times"></i>
            &nbsp;Hủy
          </el-button>
        </div>
      </template>
    </dialogTemplate>
  </div>
</template>

<script>



export default {
  name: "attach-document-name-dialog",
  props: ["isOpen"],
  filters: {},
  components: {
    dialogTemplate: () => import("../common/custom-dialog.vue")
  },
  mounted() {
  },
  mixins: [],
  data() {
    return {
      form:{
        name:null
      },
      rules: {
        name: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "blur"
          }
        ]
      }
    }
  },
  computed: {},
  created() {
  },

  methods: {

    cancel() {
      this.$emit("closeDialog");
    },
    create(){
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.$emit("success",{name:this.form.name});
      });

    }
  }
}


</script>

<style scoped>
.content {
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/attach-document-name-dialog.vue